export enum RelationshipType {
  CO_WORKER = 'CO_WORKER',
  FRIEND = 'FRIEND',
  NONE = 'NONE',
  OTHER = 'OTHER',
  RELATIVE = 'RELATIVE',
  SPOUSE = 'SPOUSE',
}
